import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import Swiper core and required modules
import SwiperCore, { Pagination } from "swiper";

// install Swiper modules
import "./Enlist.sass";
import arrows from "../../../assets/images/home-arrows.png";
import arrowsBlack from "../../../assets/images/home-arrows-black.png";

SwiperCore.use([Pagination]);

export default function Enlist() {
  return (
    <div
      className="enlist"
      style={{
        background: "url('/images/enlist-bg.png')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="enlist-arrows">
        <img src={arrows} className="not-mobile" alt="arrows" />
        <img src={arrows} className="not-mobile" alt="arrows" />
        <img src={arrows} className="not-mobile" alt="arrows" />
        <img src={arrowsBlack} className="mobile" alt="arrows" />
      </div>
      <h2 className="enlist-today">ENLIST TODAY</h2>
      <h2 className="enlist-become">BECOME A FREN !</h2>
      <h2 className="enlist-title">The Regiments</h2>

      <div className="enlist-regiments">
        <div className="enlist-kek">
          <div className="enlist-card"></div>
          <img src="/images/kek.png" alt="kek" />
        </div>
        <div className="enlist-froggods">
          <div className="enlist-card"></div>
          <img src="/images/froggods.png" alt="froggods" />
        </div>
        <div className="enlist-demigods">
          <div className="enlist-card"></div>
          <img src="/images/demigods.png" alt="demigods" />
        </div>
        <div className="enlist-frens">
          <div className="enlist-card"></div>
          <img src="/images/frens.png" alt="frens" />
        </div>
        <div className="enlist-cyberfrens">
          <div className="enlist-card"></div>
          <img src="/images/cyberfrens.png" alt="cyberfrens" />
        </div>
      </div>
      <div className="enlist-break not-mobile">
        <img src="/images/break.png" alt="brek" />
      </div>

      <Swiper
        slidesPerView={1.5}
        spaceBetween={30}
        centeredSlides={true}
        className="mySwiper"
        loop={true}
      >
        <SwiperSlide>
          <div className="enlist-card-container">
            <div className="enlist-card"></div>
            <img className="enlist-card-img" src="/images/kek.png" alt="kek" />
            <p className="enlist-card-text">KEK</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="enlist-card-container">
            <div className="enlist-card"></div>
            <img
              className="enlist-card-img"
              src="/images/froggods.png"
              alt="froggods"
            />
            <p className="enlist-card-text">FrogGods</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="enlist-card-container">
            <div className="enlist-card"></div>
            <img
              className="enlist-card-img"
              src="/images/demigods.png"
              alt="demigods"
            />
            <p className="enlist-card-text">DemiGods</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="enlist-card-container">
            <div className="enlist-card"></div>
            <img
              className="enlist-card-img"
              src="/images/frens.png"
              alt="frens"
            />
            <p className="enlist-card-text">Frens</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="enlist-card-container">
            <div className="enlist-card"></div>
            <img
              className="enlist-card-img"
              src="/images/cyberfrens.png"
              alt="cyberfrens"
            />
            <p className="enlist-card-text">CyberFrens</p>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
